import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1abe2b96"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container"
};
import CardUserInfo from './components/cardUserInfo.vue';
import Menu from './components/Menu';
export default {
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      var _component_el_col = _resolveComponent("el-col");

      var _component_router_view = _resolveComponent("router-view");

      var _component_el_row = _resolveComponent("el-row");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(CardUserInfo), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, {
        gutter: "30"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 4,
            class: "menu"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(Menu))];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 20,
            class: "right"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_router_view)];
            }),
            _: 1
          })];
        }),
        _: 1
      })])], 64);
    };
  }
};